import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCopy = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M2.743 3.825c-.36.667-.36 1.55-.36 3.315v4.11c0 1.398 0 2.097.229 2.648a3 3 0 0 0 1.623 1.624c.552.228 1.25.228 2.648.228v-2.887c0-2.207 0-3.31.45-4.144a3.75 3.75 0 0 1 1.52-1.52c.833-.449 1.936-.449 4.143-.449h2.887c0-1.398 0-2.097-.228-2.648a3 3 0 0 0-1.624-1.624c-.551-.228-1.25-.228-2.648-.228h-4.11c-1.765 0-2.647 0-3.314.36a3 3 0 0 0-1.216 1.215Zm6 6c-.36.667-.36 1.55-.36 3.315v3.72c0 1.765 0 2.648.36 3.315A3 3 0 0 0 9.96 21.39c.667.36 1.55.36 3.314.36h3.72c1.765 0 2.648 0 3.315-.36a3 3 0 0 0 1.215-1.215c.36-.667.36-1.55.36-3.315v-3.72c0-1.765 0-2.648-.36-3.315a3 3 0 0 0-1.215-1.215c-.667-.36-1.55-.36-3.315-.36h-3.72c-1.765 0-2.647 0-3.314.36a3 3 0 0 0-1.216 1.215Z",
		clipRule: "evenodd"
	})
});
const ForwardRef = forwardRef(SvgCopy);
export default ForwardRef;
